<template>
  <v-alert
    prominent
    text
    dense
    color="red"
    type="warning"
    class="py-1 w-100"
    icon="fas fa-exclamation-triangle"
  >
    <ERow align="center">
      <ECol class="py-0">
        <span class="subtitle-1">This will decommission the camera.</span>
      </ECol>
      <ECol class="shrink pl-0">
        <v-btn color="error" small @click="decommissionCamera"
          >Decommission</v-btn
        >
      </ECol>
    </ERow>
  </v-alert>
</template>

<script>
import { mapStores } from "pinia"
import { useCameraDialogStore } from "@/stores/cameraDialog"
import { useKitSummaryStore } from "@/stores/kitSummary"
import { CameraStatus } from "@evercam/shared/types/camera"

export default {
  name: "DecommissionCamera",
  computed: {
    ...mapStores(useCameraDialogStore, useKitSummaryStore),
  },
  methods: {
    async decommissionCamera() {
      if (
        await this.$confirmDialog.open({
          title: "Are you sure ?",
          message: "This will permanently decommission the camera!",
        })
      ) {
        await this.cameraDialogStore.updateCamera({
          status: CameraStatus.Decommissioned,
        })
        await this.kitSummaryStore.loadKit(this.cameraDialogStore.camera.kitId)
      }
    },
  },
}
</script>
